module.exports = __webpack_public_path__ + "static/media/data-management_3631359.1ebc29bd.svg";